export default __webpack_public_path__ + "static/media/EmptyBasket.989da316.png";